import { useMutation } from '@apollo/client';

import { RequestDjInput } from '../../apollo/__generated__/graphql';
import { REQUEST_DJ } from '../graphql/mutation/requestDjMutation.graphql';
import { CURRENT_USER_DJ } from '../graphql/query/currentUserDjQuery.graphql';

export const useRequestDjMutation = (onCompleted?: () => void) => {
  const [mutate, { loading }] = useMutation(REQUEST_DJ, {
    onCompleted,
  });

  const requestDj = (requestDjInput: RequestDjInput) => {
    mutate({
      variables: {
        requestDjInput,
      },
      refetchQueries: [CURRENT_USER_DJ],
    });
  };

  return { requestDj, loading };
};
